// extracted by mini-css-extract-plugin
module.exports =  {"modalBody":"jut__ModalBody__modalBody","hasVerticalScrollbar":"jut__ModalBody__hasVerticalScrollbar"};